module.exports = __webpack_public_path__ + "img/milad-rahatianpur.2c1060a5.jpg";